export interface WinPayFilter {
    symbol: string;
    count: number[];
}